import "./App.css";
import LoginPage from "./pages/LoginPage";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import axios from "axios";
import { apiKey } from "./config/config";
import React, { useState, useEffect } from "react";
import AdminLayout from "./layouts/AdminLayout";
import PublicContract from "./pages/PublicContract";
import LightModeLayout from "./layouts/LightModeLayout";

// let token = true;

// const PrivateRouter = (token, Component, redirectPath) => {
//   return !token ? redirectPath : <Component />;
// };

export const App = () => {
  const [language, setLanguage] = useState({});
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("AC-lang") || "ar"
  );
  const [dir, setDir] = useState("ltr");

  const currentDir = (dir) => {
    setDir(dir);
  };

  const currentLangFunc = (lang) => {
    setCurrentLang(lang);
    localStorage.setItem("AC-lang", lang);
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/get-lang?lang=${currentLang}`)
      .then((res) => {
        setLanguage(JSON.parse(res.data.result[0].lang_keys));
      })
      .catch((err) => {
        console.error(err);
      });
  }, [currentLang]);

  // useEffect(() => {
  //   console.log(currentLang)
  // }, [currentLang])

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword lang={language} />} />
          <Route path="/reset-password" element={<ResetPassword lang={language} />} />
          <Route
            path="/contract/:customer_id"
            element={
              <PublicContract
                lang={language}
                dir={dir}
                currentDir={currentDir}
                currentLangFunc={currentLangFunc}
              />
            }
          />
          <Route
            path="/dashboard/*"
            element={
              <AdminLayout
                language={language}
                dir={dir}
                currentDir={currentDir}
                currentLangFunc={currentLangFunc}
              />
            }
          />
          <Route
            path="/lightmode/dashboard/*"
            element={
              <LightModeLayout
                language={language}
                dir={dir}
                currentDir={currentDir}
                currentLangFunc={currentLangFunc}
              />
            }
          />
        </Routes>
      </BrowserRouter>
    </>
  );
};
export default App;
